import React from 'react'
import Services from '../../api/service-content'
import SectionTitle from '../SectionTitle'

const ServiceSection = (props) => {
    return (
        <div className={`wpo-service-area section-padding ${props.sClass}`}>
            <div className="container">
                <SectionTitle subTitle={'Why Choose Giga Group'} MainTitle={'Why Us'}/>
                <div className="row">
                    {Services.slice(0,6).map((service, sitem) => (
                        <div className="col-lg-4 col-md-6 col-12 wpo-service-col" key={sitem}>
                            <div className="wpo-service-item">
                                <i className={service.icon}></i>
                                <h2>{service.sTitle}</h2>
                                <p>{service.description}</p>
                                {/* <Link onClick={ClickHandler} to={`/service-single/${service.Id}`}>Learn More...</Link> */}
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    )
}

export default ServiceSection;